import PropTypes from 'prop-types';

import Text from '@zenbusiness/zui/Text';

import ContactInfoFieldset from '#client/components/ContactInfoFieldset';

const fieldsConfig = {
  email: { show: false },
  firstName: { autoFocus: false }
};

function EditView({ sectionKey }) {
  return (
    <>
      <Text component="p">
        These details will be given to the state and will become public information associated with
        your business.
      </Text>
      <ContactInfoFieldset fieldsConfig={fieldsConfig} namePrefix={sectionKey} />
    </>
  );
}

EditView.propTypes = {
  sectionKey: PropTypes.string.isRequired
};

export default EditView;
